import initPermission from './permission';

export default {
    install (Vue) {
        initPermission(Vue);
    }
};


// WEBPACK FOOTER //
// ./src/directive/index.js